/* ==========================================================================
  tools.js
========================================================================== */

'use strict'; // explicitly set 'use strict' although gulp mostly does this anyway
